/*eslint @typescript-eslint/no-empty-function: "off"*/
import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { RouteComponentProps } from '@reach/router';
import { IUsers, RootState } from 'store/store';
import messages from './Messages';
import RolesList from './RolesList';
import RoleInput from './RoleInput';
import { display } from 'components/ErrorView/ErrorDialog';
import { RolesContainer } from './styles';
import APopover from 'components/APopover';
import Button from 'components/Button/Button';
import { notifyError } from 'components/Notify/Notify';
import Input from 'components/Input/Input';
import Collapsible from 'components/Collapsible/Collapsible';
import ButtonGroup from 'components/ButtonGroup';
import {
  requireProviderTags,
  requireProviderTagsFn,
} from 'store/providers/providerSlice';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import Select from 'components/Select';
import notify from 'components/Notify';
import { appDispatch } from 'store/store';
import {
  ICompany,
  ICompanyRole,
  ICompanyRoleServer,
  TProjects,
  RoleType,
  IProjectMemberView,
} from 'store/companies/companiesTypes';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import { ITags } from 'store/providers/providerTypes';
import {
  addCompanyRole,
  addCompanyRoleFn,
  addPrefixRoles,
  addPrefixRolesFn,
  deleteCompanyRole,
  deleteCompanyRoleFn,
  getCompanyFn,
  getCompanyHandler,
  migrateRole,
  migrateRoleFn,
  migrateToProjectRoles,
  migrateToProjectRolesFn,
  updateCompanyRole,
  updateCompanyRoleFn,
} from 'store/companies/companiesSlice';
import {
  isAdvanceAdmin,
  isCompanyOwnerOrSupport,
} from '../../../../store/companies/companiesUtils';
import { produce } from 'immer';
import i18n from '../../../../i18n';

interface IStateToProps {
  company: ICompany;
  thisUser: IThisUserState;
  users: IUsers;
  projects: TProjects;
  tags: ITags['data'];
  toLoadTags: number[];
  providerIds: number[];
  isAdvancedAdmin: boolean;
}

interface IDispatchToProps {
  addRole: (role: ICompanyRoleServer) => ReturnType<typeof addCompanyRoleFn>;
  updateRole: (
    role: ICompanyRoleServer
  ) => ReturnType<typeof updateCompanyRoleFn>;
  getCompany: (companyId: number) => ReturnType<typeof getCompanyFn>;
  migrateToProjectRoles: (
    companyId: number,
    toMigrateRoleNames: string[]
  ) => ReturnType<typeof migrateToProjectRolesFn>;
  addPrefixRoles: (role: ICompanyRole) => ReturnType<typeof addPrefixRolesFn>;
  deleteRole: (
    roleId: number,
    companyId: number
  ) => ReturnType<typeof deleteCompanyRoleFn>;
  requireProviderTags: (id: number) => ReturnType<typeof requireProviderTagsFn>;
  migrateRole: (
    fromRole: number,
    toRole: number,
    deleteFrom: boolean
  ) => ReturnType<typeof migrateRoleFn>;
}

interface IOwnProps {
  companyId?: string;
}

type IComponentProps = IOwnProps &
  IStateToProps &
  IDispatchToProps &
  RouteComponentProps;

interface ICompanyRolesState {
  roles: { [key: number]: ICompanyRole };
  loading: boolean;
  rolesWillBeCreated?: Map<string, Set<string>>;
  confilictRoles?: Set<string>;
  showMigrate?: boolean;
  calculateMigrate: boolean;
  migrating: boolean;
  toMigrateRoleNames: Set<string>;
  currentProjectRoles: Set<string>;
  selectedRoleType: RoleType | 'advanced' | 'error';
  validRoleTypes: RoleType[];
  onlyRoot: boolean;
  hasError?: boolean;
  migrateFromRole?: number;
  migrateToRole?: number;
  migrateDelete?: boolean;
}

class CompanyRoles extends React.Component<
  IComponentProps,
  ICompanyRolesState
> {
  roleTypes: {
    type: RoleType | 'advanced' | 'error';
    state: {
      validRoleTypes: RoleType[];
      onlyRoot: boolean;
      hasError?: boolean;
    };
  }[] = [
    /*{
      type: 'all',
      state: {
        validRoleTypes: [],
        onlyRoot: false,
        hasError: false,
      },
    },*/
    {
      type: 'Post',
      state: {
        validRoleTypes: ['Post'],
        onlyRoot: false,
        hasError: false,
      },
    },
    {
      type: 'District',
      state: {
        validRoleTypes: ['District'],
        onlyRoot: true,
        hasError: false,
      },
    },
    {
      type: 'InProject',
      state: {
        validRoleTypes: ['InProject'],
        onlyRoot: false,
        hasError: false,
      },
    },
    {
      type: 'advanced',
      state: {
        validRoleTypes: [null],
        onlyRoot: false,
        hasError: false,
      },
    },
  ];

  componentDidMount() {
    if (this.props.toLoadTags.length) {
      this.props.toLoadTags.forEach((it) => {
        this.props.requireProviderTags(it);
      });
    }
  }

  constructor(props: IComponentProps) {
    super(props);
    this.state = {
      loading: false,
      roles: props.company.roles,
      calculateMigrate: false,
      migrating: false,
      toMigrateRoleNames: new Set<string>(),
      currentProjectRoles: new Set<string>(),
      selectedRoleType: this.roleTypes[0].type,
      ...this.roleTypes[0].state,
      hasError: false,
    };
  }

  deleteRoleItem = (roleId: number, companyId: number) => () => {
    const oldRoles = this.props.company.roles;
    const foundProjectIds: number[] = [];
    Object.values(this.props.projects || {}).forEach((project) => {
      if (project.companyId === Number(this.props.companyId)) {
        const hasMemberWithRelatedRole =
          Object.values(project.projectMembers || {}).find((membership) => {
            return (
              membership.relatedRoleId === roleId ||
              membership.projectRoleId === roleId ||
              membership.roleId === roleId
            );
          }) ||
          Object.values(project.projectRoleMembers || {}).find((membership) => {
            return (
              membership.relatedRoleId === roleId ||
              membership.projectRoleId === roleId ||
              membership.roleId === roleId
            );
          });
        if (hasMemberWithRelatedRole) foundProjectIds.push(project.id);
      }
    });
    if (foundProjectIds.length > 0) {
      alert(
        messages.roleUsedIn(
          oldRoles[roleId],
          this.props.projects,
          foundProjectIds
        )
      );
      return;
    }
    if (!confirm(messages.roleDeleteCheck(oldRoles[roleId]))) {
      return;
    }
    this.props
      .deleteRole(roleId, companyId)
      .then(() => {
        const newRoles = produce(oldRoles, (draft) => {
          delete draft[roleId];
        });

        this.setState({ roles: newRoles, loading: false });
      })
      .catch((err: any) => {
        this.setState({ loading: false });
        display(err);
      });
  };

  addRoleItem = (item: ICompanyRoleServer) => {
    this.setState({ loading: true });
    return this.props
      .addRole(item)
      .then(({ role }) => {
        const roles = cloneDeep(this.state.roles);
        roles[role.id as number] = role;
        this.setState({ roles, loading: false });
      })
      .catch((err: any) => {
        this.setState({ loading: false });
        display(err);
      });
  };

  calculateMigrate = () => {
    this.setState({ calculateMigrate: true });
    this.props.getCompany(Number(this.props.companyId)).then(() => {
      const titles = new Map<string, Set<string>>();
      const currentNoneProjectRoles = new Set<string>();
      const currentProjectRoles = new Set<string>();
      const conflictedRoles = new Set<string>();
      Object.values(this.state.roles).forEach((role) => {
        if (!role.isProjectRole)
          currentNoneProjectRoles.add(
            role.name
              .replace(/\s+/g, ' ')
              .trim()
              .replace(/^‌+|‌+$/g, '')
          );
        else
          currentProjectRoles.add(
            role.name
              .replace(/\s+/g, ' ')
              .trim()
              .replace(/^‌+|‌+$/g, '')
          );
      });
      Object.values(this.props.projects || {}).forEach((project) => {
        [
          ...Object.entries(project.projectRoleMembers || {}),
          ...Object.entries(project.projectMembers || {}),
        ]?.forEach(([_, member]) => {
          let title = member.title;
          if (title) {
            title = title
              .replace(/\s+/g, ' ')
              .trim()
              .replace(/^‌+|‌+$/g, '');
            if (!titles.has(title)) titles.set(title, new Set<string>());
            titles.get(title)!.add(project.name);
            if (currentNoneProjectRoles.has(title)) conflictedRoles.add(title);
          }
        });
      });
      this.setState({
        rolesWillBeCreated: titles,
        confilictRoles: conflictedRoles,
        calculateMigrate: false,
        toMigrateRoleNames: currentProjectRoles,
        currentProjectRoles,
      });
    });
  };

  updateRoleItem = (item: ICompanyRoleServer) => {
    if (!item.id) return this.addRoleItem(item);
    return this.props.updateRole(item).then(({ role }) => {
      const roles = cloneDeep(this.state.roles);
      roles[role.id as number] = role;
      this.setState({ roles });
    });
  };

  render() {
    const {
      showMigrate,
      loading,
      confilictRoles,
      rolesWillBeCreated,
      calculateMigrate,
      toMigrateRoleNames,
      currentProjectRoles,
      migrating,
    } = this.state;
    const { companyId, projects, tags, providerIds, company } = this.props;

    const projectTags = Object.values(projects || {}).reduce(
      (current: Set<string>, item) => {
        if (item.companyId === Number(companyId)) {
          item.tags?.forEach((it: string) => {
            current.add(it);
          });
        }
        return current;
      },
      new Set<string>()
    );

    const allRoles = Object.values(this.props.company.roles) as ICompanyRole[];
    const projectsArray = Object.values(projects || {});
    const withErrorRoles = allRoles.find((it) => {
      return this.roleHasError(it, projectsArray);
    });
    const allRoleOptions =
      allRoles
        ?.filter((it) => !it.isProjectRole)
        ?.map((it) => ({
          value: it.id,
          label: it.name,
          type: it.roleType,
        })) || [];

    const filteredRoles: ICompanyRole[] = allRoles.filter((it) => {
      if (this.state.onlyRoot && (it.surroundingMeRoles?.length ?? 0) > 0)
        return false;
      if (
        this.state.validRoleTypes.length > 0 &&
        !this.state.validRoleTypes.includes(it.roleType!)
      )
        return false;

      if (this.state.hasError) return this.roleHasError(it, projects);

      return true;
    });

    if (this.props.toLoadTags.length) return <LoadingIndicator />;
    const extraType = withErrorRoles
      ? [
          {
            type: 'error',
            state: {
              validRoleTypes: [],
              onlyRoot: false,
              hasError: true,
            },
          },
        ]
      : [];

    const isOwnerOrSupport = isCompanyOwnerOrSupport(
      this.props.thisUser,
      company
    );
    //   Number(this.props.thisUser.userId) === this.props.company.owner.userId;
    // const isSupport = !!Object.values(
    //   company.members[Number(thisUser.userId)].roles
    // )?.find((it: any) => it.name.includes(SupportRole));

    const finalRoleTypes = [...extraType, ...this.roleTypes].filter((it) => {
      return isOwnerOrSupport || it.type !== 'advanced';
    });
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '20px',
          height: '100%',
        }}
      >
        <div style={{ width: '100px', flexShrink: 0 }}>
          <ButtonGroup
            items={finalRoleTypes.reduce((current, item) => {
              current[item.type!] = i18n.t(`${item.type!}`, {
                ns: 'companyManagement',
              });
              return current;
            }, {})}
            selected={this.state.selectedRoleType!}
            onSelect={(type) =>
              this.setState({
                ...finalRoleTypes.find((it) => it.type === type)!.state,
                selectedRoleType: type as RoleType,
              })
            }
            vertical
            gap={'5px'}
          />
        </div>
        <RolesContainer>
          <h5>
            {this.state.selectedRoleType === 'advanced'
              ? (i18n.t('requireSetRoleType', {
                  ns: 'companyManagement',
                }) as string)
              : (i18n.t(`${this.state.selectedRoleType || 'all'}`, {
                  ns: 'companyManagement',
                }) as string)}
          </h5>
          {
            <>
              {this.state.selectedRoleType !== 'advanced' &&
                this.state.selectedRoleType !== 'error' &&
                (this.state.selectedRoleType !== 'District' ||
                  isOwnerOrSupport) &&
                (this.state.selectedRoleType !== 'InProject' ||
                  isOwnerOrSupport) && (
                  <Collapsible
                    defaultOpen={!filteredRoles.length}
                    header={
                      i18n.t('addName', {
                        ns: 'companyManagement',
                        name: `${this.state.selectedRoleType === 'Post' ? i18n.t('Post', { ns: 'companyManagement' }) : this.state.selectedRoleType === 'District' ? i18n.t('District', { ns: 'companyManagement' }) : this.state.selectedRoleType === 'InProject' ? i18n.t('InProject', { ns: 'companyManagement' }) : ''}`,
                      }) as string
                    }
                    iconName={'plus'}
                    nested
                    style={{ overflow: 'visible' }}
                  >
                    <RoleInput
                      addOrUpdateRole={this.addRoleItem}
                      loading={loading}
                      companyId={Number(companyId)}
                      cancelEdit={() => {}}
                      maxRoleOrder={filteredRoles.reduce((current, item) => {
                        if ((item.order ?? 0) > current) return item.order || 0;
                        return current;
                      }, -10000)}
                      allProjectTags={Array.from(projectTags)}
                      allRoles={allRoles}
                      roleType={this.state.selectedRoleType}
                      // @ts-expect-error it's ok
                      tags={tags}
                      providerIds={providerIds}
                      hideAdvancedConfig={!isOwnerOrSupport}
                    />
                  </Collapsible>
                )}
              <RolesList
                roles={filteredRoles}
                allRoles={allRoles}
                deleteRole={this.deleteRoleItem}
                updateRole={this.updateRoleItem}
                addPrefixRoles={this.props.addPrefixRoles}
                allProjectTags={Array.from(projectTags)}
                users={this.props.users}
                projects={projects}
                enableReOrder={true}
                // @ts-expect-error it's ok
                tags={tags}
                providerIds={providerIds}
                isAdvancedEditor={isOwnerOrSupport}
                isAdvancedAdmin={this.props.isAdvancedAdmin}
              />
            </>
          }
          {this.state.selectedRoleType === 'advanced' && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <Collapsible
                header={
                  i18n.t('migrateRole', {
                    ns: 'companyManagement',
                  }) as string
                }
                style={{ overflow: 'visible' }}
              >
                <div>
                  <Select
                    values={allRoleOptions.filter(
                      (it) => this.state.migrateFromRole === it.value
                    )}
                    options={allRoleOptions}
                    multiChoice={false}
                    onChangeValues={(selected) => {
                      this.setState({
                        migrateFromRole: Number(selected[0]?.value),
                      });
                    }}
                    label={
                      i18n.t('migrateFrom', {
                        ns: 'companyManagement',
                      }) as string
                    }
                  />
                  <Select
                    values={allRoleOptions.filter(
                      (it) => this.state.migrateToRole === it.value
                    )}
                    options={allRoleOptions}
                    multiChoice={false}
                    onChangeValues={(selected) => {
                      this.setState({
                        migrateToRole: Number(selected[0]?.value),
                      });
                    }}
                    label={
                      i18n.t('migrateTo', {
                        ns: 'companyManagement',
                      }) as string
                    }
                  />
                  <Input
                    id={'deleteSourceRole'}
                    type={'checkbox'}
                    checked={this.state.migrateDelete}
                    label={
                      i18n.t('migrateDelete', {
                        ns: 'companyManagement',
                      }) as string
                    }
                    onChange={(e) => {
                      this.setState({ migrateDelete: e.target.checked });
                    }}
                  />
                  <Button
                    loading={migrating}
                    disabled={
                      !this.state.migrateFromRole || !this.state.migrateToRole
                    }
                    className="my-3"
                    onClick={() => {
                      this.setState({ migrating: true });
                      this.props
                        .migrateRole(
                          this.state.migrateFromRole!,
                          this.state.migrateToRole!,
                          this.state.migrateDelete!
                        )
                        .then(
                          () => {
                            notify(
                              i18n.t('doneMigrate', {
                                ns: 'companyManagement',
                              }) as string
                            );
                          },
                          (e) => {
                            notifyError(e);
                          }
                        )
                        .finally(() => {
                          this.setState({ migrating: false });
                        });
                    }}
                  >
                    {
                      i18n.t('doMigrate', {
                        ns: 'companyManagement',
                      }) as string
                    }
                  </Button>
                </div>
              </Collapsible>
              <APopover
                target={
                  <p>
                    {
                      i18n.t('migrateProjectRoles', {
                        ns: 'companyManagement',
                      }) as string
                    }
                  </p>
                }
                onShowChange={(show) => {
                  if (show) this.calculateMigrate();
                  this.setState({ showMigrate: show });
                }}
                show={showMigrate}
                trigger={'click'}
                arrow
                curveBorder
                placement={'top'}
              >
                <div
                  style={{ height: '70vh', width: '80vw', overflow: 'auto' }}
                >
                  <h5>
                    {
                      i18n.t('rolesWillBeCreated', {
                        ns: 'companyManagement',
                      }) as string
                    }
                  </h5>
                  <p>
                    {
                      i18n.t('openToSeeProjectInfoText', {
                        ns: 'companyManagement',
                      }) as string
                    }
                  </p>
                  <div>
                    {Array.from(rolesWillBeCreated?.entries() ?? []).map(
                      ([key, value]) => {
                        return (
                          <details key={key}>
                            <summary>
                              <li style={{ display: 'flex' }}>
                                <Input
                                  id={`check_${key}`}
                                  type="checkbox"
                                  checked={
                                    toMigrateRoleNames.has(key) ||
                                    currentProjectRoles.has(key)
                                  }
                                  disabled={
                                    confilictRoles?.has(key) ||
                                    currentProjectRoles.has(key)
                                  }
                                  onChange={(e) => {
                                    const newMigrate = new Set<string>(
                                      toMigrateRoleNames
                                    );
                                    if (e.target.checked) {
                                      newMigrate.add(key);
                                    } else {
                                      newMigrate.delete(key);
                                    }
                                    this.setState({
                                      toMigrateRoleNames: newMigrate,
                                    });
                                  }}
                                />{' '}
                                {'«' + key + '»'}
                              </li>
                            </summary>
                            <span style={{ whiteSpace: 'pre-wrap' }}>
                              {' (' + Array.from(value) + ') '}
                            </span>
                          </details>
                        );
                      }
                    )}
                  </div>
                  <Button
                    loading={migrating || calculateMigrate}
                    disabled={
                      !calculateMigrate && toMigrateRoleNames.size === 0
                    }
                    color={'red'}
                    onClick={() => {
                      this.setState({ migrating: true });
                      this.props
                        .migrateToProjectRoles(
                          Number(this.props.companyId),
                          Array.from(toMigrateRoleNames)
                        )
                        .then(
                          () => {
                            this.setState({ migrating: true });
                            window.location.reload();
                          },
                          (e: any) => {
                            notifyError(e);
                          }
                        );
                    }}
                  >
                    {
                      i18n.t('migrate', {
                        ns: 'companyManagement',
                      }) as string
                    }
                  </Button>
                </div>
              </APopover>
            </div>
          )}
        </RolesContainer>
      </div>
    );
  }

  private roleHasError(it: ICompanyRole, projects: TProjects) {
    if (it.isUnique && it.users.length !== 1) return true;
    if (it.roleType === 'District' && !it.relatedTagId) return true;
    if (it.users.length === 0) {
      const projectIncludesMe = Object.values(projects || {}).find((item) => {
        const iProjectMemberViews = Object.values(item.projectRoleMembers);
        const foundMembership = iProjectMemberViews.find(
          (pm: IProjectMemberView) => {
            return pm.roleId === it.id;
          }
        );
        return !!foundMembership;
      });
      if (projectIncludesMe) return true;
    }
    return false;
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const companyId = Number(props.companyId);
  const company = state.companies.data[companyId];
  const projects = company.projects;
  const thisUser = state.thisUser;
  const users = state.users;
  const providerIds = Object.values(state.providers.map).reduce(
    (current: number[], it: any) => {
      if (it.data.managingCompanyId === companyId) current.push(it.data.id);

      return current;
    },
    [] as number[]
  );
  let tags: ITags['data'] = {};
  const toLoadTags = [] as number[];
  providerIds.forEach((id: number) => {
    if (!state.providers.tags[id]?.status) toLoadTags.push(id);
    tags = {
      ...tags,
      ...(state.providers.tags[id]?.data || {}),
    };
  });
  const isAdvancedAdmin = isAdvanceAdmin(thisUser, company) || false;
  return {
    users,
    company,
    thisUser,
    projects,
    tags,
    toLoadTags,
    providerIds,
    isAdvancedAdmin,
  };
};

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  IOwnProps
> = () => {
  return {
    addRole: (role: ICompanyRoleServer) =>
      appDispatch(addCompanyRole({ role })),
    addPrefixRoles: (role: ICompanyRoleServer) =>
      appDispatch(addPrefixRoles({ role })),
    updateRole: (role: ICompanyRoleServer) =>
      appDispatch(updateCompanyRole({ role })),
    deleteRole: (roleId: number, companyId: number) =>
      appDispatch(deleteCompanyRole({ roleId, companyId })),
    requireProviderTags: (providerId: number) =>
      appDispatch(requireProviderTags({ providerId })),
    getCompany: (companyId: number) =>
      appDispatch(
        getCompanyHandler({
          companyId,
          templateStub: false,
          companyStub: false,
          projectStub: false,
          taskStub: true,
        })
      ),
    migrateToProjectRoles: (companyId: number, toMigrateRoleNames: string[]) =>
      appDispatch(migrateToProjectRoles({ companyId, toMigrateRoleNames })),
    migrateRole: (fromRole: number, toRole: number, deleteFrom: boolean) =>
      appDispatch(migrateRole({ fromRole, toRole, deleteFrom })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyRoles);
